import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  requiredPermissions?: string[];
  element: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredPermissions = [], element }) => {
  const { isAuthenticated, hasPermission, checkAuth } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (currentPath === '/login') {
    return <Navigate to="/" replace />;
  }

  if (requiredPermissions.length > 0 && !hasPermission(requiredPermissions)) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return element;
};

export default ProtectedRoute;




